module.exports = __webpack_public_path__ + "static/accreditations6-56d8d69d8e45dfb2968a1d5ee021320c.png";